/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EAcademicEducation } from "../types/EAcademicEducation.ts";

/**
 * @description 1 = UndergraduateDegree | 2 = Technologist | 3 = PostgraduateDegree | 4 = MasterDegree | 5 = DoctorateDegree | 6 = BachelorDegree | 7 = HighSchool | 8 = Specialist |
 */
export const eAcademicEducationSchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
  ])
  .describe(
    "1 = UndergraduateDegree | 2 = Technologist | 3 = PostgraduateDegree | 4 = MasterDegree | 5 = DoctorateDegree | 6 = BachelorDegree | 7 = HighSchool | 8 = Specialist | ",
  ) as unknown as ToZod<EAcademicEducation>;
